// extracted by mini-css-extract-plugin
export default {"adTit_mobile":"Vision_adTit_mobile__egd2f"};